<template>
  <div class="az-lotes-itens">
    <div v-if="possuiGrupos" class="container-grupos">
      <h3 class="titulo-secao" style="color: #0067A5">Grupos</h3>
      <v-expansion-panel v-model="paineisGrupos" expand class="painel-grupos">
        <v-expansion-panel-content v-for="grupo in grupos" :key="grupo.loteId" class="painel-grupos__linha" style="color: #104D75">
          <template v-slot:header>
            <div class="cabecalho-grupo">
              <strong>{{ grupo.resumoDescricao }}</strong>
              <span class="info-grupo"> ({{ grupo.itens.length }} {{ grupo.itens.length === 1 ? 'item' : 'itens' }}) </span>
            </div>
          </template>

          <v-data-table
            :headers="headersTabelaItensGrupo"
            :items="grupo.itens"
            :loading="carregando"
            :disable-initial-sort="true"
            hide-actions
            class="az-table-list tabela-itens-grupo"
          >
            <template v-slot:items="{ item }">
              <td>{{ getTipoItemFromItemRow(item) }}</td>
              <td>{{ getSequenciaFromItemRow(item) }}</td>
              <td class="descricao-col">
                <v-tooltip top class="tooltip-arredondado">
                  <template #activator="{ on, attrs }">
                    <chip-round
                      v-bind="attrs"
                      v-on="on"
                      :label="getTipoMaterialServico(item.itemLicitacao && item.itemLicitacao.tipo, 'sigla')"
                      :tamanho-fonte="'11px'"
                    />
                  </template>
                  <span style="white-space: nowrap;">
                    {{ getTipoMaterialServico(item.itemLicitacao && item.itemLicitacao.tipo, 'text') }}
                  </span>
                </v-tooltip>
                <span class="mr-1">{{ (item.itemLicitacao && item.itemLicitacao.codigo) }} - </span>
                <span class="descricao-wrapper" :title="item.itemLicitacao && item.itemLicitacao.descricaoCompleta">
                  <span class="descricao-texto">{{ getDescricaoExibicao(item) }}</span>
                  <template v-if="temDescricaoLonga(item)">
                    &#160;
                    <button
                      class="link-toggle"
                      @click.stop="alternarDescricao(item)"
                      type="button"
                      :aria-expanded="isDescricaoExpandida(item) ? 'true' : 'false'"
                    >
                      {{ isDescricaoExpandida(item) ? 'ver menos' : 'ver mais' }}
                    </button>
                  </template>
                </span>
              </td>
              <td class="no-wrap">{{ item.itemLicitacao && item.itemLicitacao.unidadeDescricao }}</td>
              <td style="text-align: right;">
                <formatador-moeda :valor="item.quantidade" :casas-decimais="casasDecimaisQuantidade" />
              </td>
              <td style="text-align: right;">
                <formatador-moeda :valor="item.valorUnitario" :casas-decimais="casasDecimais" />
              </td>
              <td style="text-align: right;">
                <formatador-moeda :valor="item.valorTotal" :casas-decimais="2" />
              </td>
            </template>
          </v-data-table>

          <div class="total-grupo" v-if="exibirTotaisGerais">
            <div class="resume">
              <label>Total do Grupo: </label>
              <span>R$ <formatador-moeda :valor="grupo.totalGrupo" :casas-decimais="2" /></span>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>

    <div v-if="possuiItensIndividuais" class="container-itens-individuais">
      <h3 class="titulo-secao" :class="{ 'mt-4': possuiGrupos }" style="color: #0067A5">Itens</h3>
      <v-flex xs12 sm12 d-flex>
        <v-data-table
          :headers="headersTabelaItens"
          :items="itensIndividuais"
          :loading="carregando"
          :disable-initial-sort="true"
          hide-actions
          class="az-table-list tabela-itens-individuais"
        >
          <template v-slot:items="{ item }">
            <td>{{ getTipoItemFromItemRow(item) }}</td>
            <td>{{ getSequenciaFromItemRow(item) }}</td>
            <td class="descricao-col">
              <v-tooltip top class="tooltip-arredondado">
                <template #activator="{ on, attrs }">
                  <chip-round
                    v-bind="attrs"
                    v-on="on"
                    :label="getTipoMaterialServico(item.itemLicitacao && item.itemLicitacao.tipo, 'sigla')"
                    :tamanho-fonte="'11px'"
                  />
                </template>
                <span style="white-space: nowrap;">
                  {{ getTipoMaterialServico(item.itemLicitacao && item.itemLicitacao.tipo, 'text') }}
                </span>
              </v-tooltip>
              <span class="mr-1">{{ (item.itemLicitacao && item.itemLicitacao.codigo) }} - </span>
              <span class="descricao-wrapper" :title="item.itemLicitacao && item.itemLicitacao.descricaoCompleta">
                <span class="descricao-texto">{{ getDescricaoExibicao(item) }}</span>
                <template v-if="temDescricaoLonga(item)">
                  &#160;
                  <button
                    class="link-toggle"
                    @click.stop="alternarDescricao(item)"
                    type="button"
                    :aria-expanded="isDescricaoExpandida(item) ? 'true' : 'false'"
                  >
                    {{ isDescricaoExpandida(item) ? 'ver menos' : 'ver mais' }}
                  </button>
                </template>
              </span>
            </td>
            <td class="no-wrap">{{ item.itemLicitacao && item.itemLicitacao.unidadeDescricao }}</td>
            <td style="text-align: right;">
              <formatador-moeda :valor="item.quantidade" :casas-decimais="casasDecimaisQuantidade" />
            </td>
            <td style="text-align: right;">
              <formatador-moeda :valor="item.valorUnitario" :casas-decimais="casasDecimais" />
            </td>
            <td style="text-align: right;">
              <formatador-moeda :valor="item.valorTotal" :casas-decimais="2" />
            </td>
          </template>
        </v-data-table>
      </v-flex>

      <div class="resume-itens" v-if="possuiItensIndividuais && exibirTotaisGerais">
        <div class="resume">
          <label>Total Itens Individuais: </label>
          <span>R$ <formatador-moeda :valor="totalItensIndividuais" :casas-decimais="2" /></span>
        </div>
      </div>
    </div>

    <div class="resume-itens" v-if="possuiLotes && exibirTotaisGerais">
      <div class="resume">
        <label>Total Unitário: </label>
        <span>R$ <formatador-moeda :valor="totalUnitario" :casas-decimais="casasDecimais" /></span>
        <span class="separator">|</span>
        <label>Total Geral: </label>
        <span>R$ <formatador-moeda :valor="totalGeral" :casas-decimais="2" /></span>
      </div>
    </div>

    <div v-if="!carregando && !possuiLotes" class="az-empty-state">
      <v-alert :value="true" type="info" outlined>
        Ops! Nenhum lote encontrado. Nenhum lote cadastrado para este credenciamento.
      </v-alert>
    </div>
  </div>
</template>

<script>
import FormatadorMoeda from '@/views/components/FormatadorMoeda.vue'
import ChipRound from './ChipRound.vue'
import { actionTypes } from '@/core/constants'
import { normalizarCasasDecimais } from '@/core/utils/CasasDecimaisUtils'

export default {
    name: 'CredenciamentoVisualizacaoLotesItens',
    components: { FormatadorMoeda, ChipRound },
    props: {
        licitacaoId: {
            type: [Number, String],
            required: false
        },
        casasDecimaisProp: {
            type: Number,
            required: false,
            default: 2
        }
    },
    data() {
        return {
            itensLotes: [],
            carregando: false,
            paineisGrupos: [],
            expandedDescricoes: {}
        }
    },
    computed: {
        licitacao() {
            return (this.$store && this.$store.state && this.$store.state.licitacao) || {}
        },
        casasDecimais() {
            return normalizarCasasDecimais(this.licitacao.casasDecimais, normalizarCasasDecimais(this.casasDecimaisProp))
        },
        casasDecimaisQuantidade() {
            return normalizarCasasDecimais(this.licitacao.casasDecimaisQuantidade)
        },
        possuiLotes() {
            return this.itensLotes && this.itensLotes.length > 0
        },
        grupos() {
            const gruposMap = new Map()
            this.itensLotes.forEach(item => {
                const resumo = item.loteLicitacao && item.loteLicitacao.resumoDescricao
                if (resumo && (resumo.toLowerCase().includes('lote') || resumo.toLowerCase().includes('grupo'))) {
                    const loteId = item.loteLicitacao && item.loteLicitacao.id
                    if (!gruposMap.has(loteId)) {
                        gruposMap.set(loteId, { loteId, resumoDescricao: resumo, itens: [], totalGrupo: 0 })
                    }
                    const grupo = gruposMap.get(loteId)
                    grupo.itens.push(item)
                    grupo.totalGrupo += (item.valorTotal || 0)
                }
            })
            return Array.from(gruposMap.values())
        },
        itensIndividuais() {
            return this.itensLotes.filter(item => {
                const resumo = item.loteLicitacao && item.loteLicitacao.resumoDescricao
                return !resumo || (!resumo.toLowerCase().includes('lote') && !resumo.toLowerCase().includes('grupo'))
            })
        },
        possuiGrupos() {
            return this.grupos.length > 0
        },
        possuiItensIndividuais() {
            return this.itensIndividuais.length > 0
        },
        totalGeral() {
            return this.itensLotes.reduce((acc, it) => acc + (Number(it.valorTotal) || 0), 0)
        },
        totalUnitario() {
            return this.itensLotes.reduce((acc, it) => acc + (Number(it.valorUnitario) || 0), 0)
        },
        totalItensIndividuais() {
            return this.itensIndividuais.reduce((acc, it) => acc + (Number(it.valorTotal) || 0), 0)
        },
        exibirTotaisGerais() {
            return this.possuiLotes
        },
        headersTabelaItensGrupo() {
            return this.headersBase
        },
        headersTabelaItens() {
            return this.headersBase
        },
        headersBase() {
            return [
                { text: 'Tipo', align: 'left', sortable: false, value: 'tipoItem', width: '100px', class: 'primary--text' },
                { text: 'Seq.', align: 'left', sortable: false, value: 'sequencia', width: '80px', class: 'primary--text' },
                { text: 'Código/Descrição', value: 'descricao', sortable: false, align: 'left', class: 'primary--text' },
                { text: 'Un. Aquisição', value: 'unidade', sortable: false, align: 'center', class: 'primary--text' },
                { text: 'Quantidade', value: 'quantidade', sortable: false, align: 'center', width: '100px', class: 'primary--text' },
                { text: 'Vlr. Unitário', value: 'valorUnitario', sortable: false, align: 'right', width: '120px', class: 'primary--text' },
                { text: 'Vlr. Total', value: 'valorTotal', sortable: false, align: 'center', width: '120px', class: 'primary--text' }
            ]
        }
    },
    watch: {
        grupos: {
            handler() {
                this.paineisGrupos = this.grupos.map(() => true)
            },
            immediate: true
        }
    },
    methods: {
        async carregar() {
            try {
                this.carregando = true
                const id = this.licitacaoId || (this.$route && this.$route.params && this.$route.params.id)
                if (!id) { this.carregando = false; return }
                const data = await this.$store.dispatch(actionTypes.BUSCAR_ITENS_LOTES_CREDENCIAMENTO, id)
                this.itensLotes = Array.isArray(data) ? data : []
            } catch (e) {
                console.error(e)
            } finally {
                this.carregando = false
            }
        },
        getTipoMaterialServico(tipo, retorno) {
            const mod = (require('@/commons/constants/tipo-item-material-servico').default || {})
            const lista = Object.values(mod)
            const norm = v => (v || '').toString().trim().toUpperCase()
            const t = norm(tipo)
            let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t)
            if (!item) {
                if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL')
                if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO')
            }
            return item ? item[retorno] : null
        },
        containsIgnoreCase(src, needle) {
            if (!src || !needle) return false
            try { return new RegExp(needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i').test(src) } catch (e) { return false }
        },
        isGrupoDesc(desc) { return this.containsIgnoreCase(desc, 'grupo') || this.containsIgnoreCase(desc, 'lote') },
        isItemDesc(desc) { return this.containsIgnoreCase(desc, 'item') },
        extractNumberFromDesc(desc, keyword) {
            if (!desc) return null
            const cleaned = desc.replace(new RegExp(keyword, 'ig'), '').trim()
                .replace(/[^0-9.]+/g, '')
                .replace(/^[.]+|[.]+$/g, '')
            return cleaned && cleaned.length ? cleaned : null
        },
        getLoteDesc(row) {
            try {
                const lote = row && row.loteLicitacao ? row.loteLicitacao : null
                if (!lote) return null
                return lote.descricao || lote.resumoDescricao || null
            } catch (e) { return null }
        },
        getTipoItemFromItemRow(row) {
            const desc = this.getLoteDesc(row)
            if (this.isGrupoDesc(desc)) return desc
            if (this.isItemDesc(desc)) return 'Item'
            return 'Item'
        },
        getSequenciaFromItemRow(row) {
            const desc = this.getLoteDesc(row)
            if (this.isGrupoDesc(desc)) {
                return row && row.numSequencia != null ? row.numSequencia : null
            }
            if (this.isItemDesc(desc)) {
                return this.extractNumberFromDesc(desc, 'item')
            }
            return row && row.numSequencia != null ? row.numSequencia : null
        },
        getItemKey(item) {
            const loteId = item && item.loteLicitacao && item.loteLicitacao.id
            const seq = item && item.numSequencia
            const codigo = item && item.itemLicitacao && item.itemLicitacao.codigo
            return `${loteId || 'no-lote'}-${seq || 'no-seq'}-${codigo || 'no-cod'}`
        },
        getDescricao(item) {
            return (item && item.itemLicitacao && item.itemLicitacao.descricaoCompleta) || ''
        },
        temDescricaoLonga(item) {
            const desc = this.getDescricao(item)
            return desc && desc.length > 150
        },
        isDescricaoExpandida(item) {
            const key = this.getItemKey(item)
            return !!this.expandedDescricoes[key]
        },
        alternarDescricao(item) {
            const key = this.getItemKey(item)
            const atual = !!this.expandedDescricoes[key]
            this.$set(this.expandedDescricoes, key, !atual)
        },
        getDescricaoExibicao(item) {
            const desc = this.getDescricao(item)
            if (!this.temDescricaoLonga(item)) return desc
            return this.isDescricaoExpandida(item) ? desc : `${desc.substring(0, 150)}...`
        }
    },
    mounted() {
        this.carregar()
    }
}
</script>

<style scoped>
.az-lotes-itens { width: 100%; }
.no-wrap { white-space: nowrap; }
.titulo-secao { margin-bottom: 15px; font-size: 18px; font-weight: bold; }
.container-grupos, .container-itens-individuais { margin-bottom: 20px; }
.painel-grupos__linha { border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 10px; }
.cabecalho-grupo { display: flex; align-items: center; gap: 10px; width: 100%; }
.info-grupo { color: #666; font-size: 12px; font-weight: normal; }
.az-table-list { width: 100%; }
.total-grupo { text-align: right; padding: 10px 0; border-top: 1px solid #f0f0f0; margin-top: 10px; }
.resume-itens { display: block; margin-bottom: 20px; margin-top: 10px; text-align: end; width: 100%; }
.resume { display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
.total-grupo .resume label, .resume-itens .resume label { font-weight: bold; font-size: 13px; color: #777777; }
.total-grupo .resume span, .resume-itens .resume span { font-weight: normal; font-size: 13px; color: #777777; }
.separator { margin: 0 8px; color: #888; }
.descricao-col { display: flex; align-items: center; gap: 8px; }
.texto-ellipsis { display: inline-block; max-width: 520px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.descricao-texto { display: inline; white-space: normal; word-break: break-word; }
.link-toggle { background: none; border: none; padding: 0; margin: 0; color: #1976D2; cursor: pointer; font-size: 12px; text-decoration: underline; }
</style>